import React from 'react';

const WelcomeSection: React.FC = () => {
  return (
    <section className="section bg-white/80 backdrop-blur-sm">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Welcome Card */}
        <div className="lg:col-span-1">
          <div className="maritime-card p-8 h-full">
            <h2 className="text-2xl font-bold text-deep-800 mb-6 flex items-center">
              <svg className="w-8 h-8 mr-3 text-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-1l-4 4z" />
              </svg>
              WELCOME
            </h2>
            <p className="text-gray-700 leading-relaxed">
              <strong className="text-primary-600">PetroMarine</strong> envisions itself to be one of the 
              leading players and solutions providers in the Offshore Business. With an enthusiastic approach 
              and defined objectives, the Company is committed to provide quality service tailored to the 
              requirements of the Clients.
            </p>
          </div>
        </div>

        {/* Egypt Office Card */}
        <div className="lg:col-span-1">
          <div className="maritime-card p-8 h-full bg-gradient-to-br from-primary-50 to-primary-100">
            <h2 className="text-2xl font-bold text-deep-800 mb-6 flex items-center">
              <span className="text-primary-600 font-bold mr-2">PETROMARINE</span>
              <span className="text-red-600 font-bold">EGYPT</span>
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong className="text-primary-600">PetroMarine</strong> Offshore Projects Support Company 
              has been established since the 70s and formed in 1992 with new culture then re-formed up to world 
              class standards in 2009. The head office is located in Cairo, Egypt.
            </p>
            <div className="bg-white/60 rounded-lg p-4 mt-4">
              <div className="flex items-center text-sm text-gray-600">
                <svg className="w-4 h-4 mr-2 text-primary-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                Head Office - Cairo, Egypt
              </div>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default WelcomeSection;